/* Publish by EComposer at 2025-07-31 20:12:52*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jrcpri0u3rs"]=  window.__ectimmers["ecom-jrcpri0u3rs"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-jrcpri0u3rs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jrcpri0u3rs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4lfh3d09n7q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4lfh3d09n7q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kac241n8fp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kac241n8fp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f65eerjd1se').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f65eerjd1se', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-71w0hsg80qj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-71w0hsg80qj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qnz117c3hy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qnz117c3hy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nc1lrpq1uop').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nc1lrpq1uop', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6za8xblqd3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6za8xblqd3', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-3f6jrn9zpzi"]=  window.__ectimmers["ecom-3f6jrn9zpzi"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-3f6jrn9zpzi"]["9vjm8gepl"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-3f6jrn9zpzi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3f6jrn9zpzi', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ku9smrpvqj"]=  window.__ectimmers["ecom-ku9smrpvqj"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-ku9smrpvqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ku9smrpvqj', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h567tfy6k9u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h567tfy6k9u', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sra1oc9tkv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sra1oc9tkv', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}